import { PictureDTO } from "./picture.dto";

export class CommunityDTO{
    eventData: CommunityEventDTO = new CommunityEventDTO();
    startDateTime: string[] = []
    endDateTime: string[] = []
    lastMessage: string = '';
    unreadMsgCount: number = 0;
    isMuted: boolean = false;
    createdAt: Date = new Date();

    constructor(data: Partial<CommunityDTO> = {}){
        for(let key in data){
            this[key] = data[key];
        }
    }
  }

  export class CommunityEventDTO{
    eventId: number;
    title: string = ''
    description: string = ''
    eventPics: PictureDTO[] = []

    constructor(data: Partial<CommunityEventDTO> = {}){
        for(let key in data){
            if(key === 'eventPics'){
                this[key] = data[key].map(i => new PictureDTO(i));
            }else{
                this[key] = data[key];
            }
        }
    }
  }